import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BreakEarlyArea, BreakEarlyService } from './break-early.service';
import { ReasonDialogComponent } from 'src/app/main/reason-dialog/reason-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { CalendarService } from '../services/calendar.service';
import { MatButton } from '@angular/material/button';
import { NgFor, NgIf, DatePipe } from '@angular/common';
import { MatCard, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';

@Component({
    selector: 'app-break-early',
    templateUrl: './break-early.component.html',
    styleUrls: ['./break-early.component.scss'],
    imports: [MatButton, NgFor, MatCard, MatCardTitle, MatCardContent, NgIf, MatCardActions, DatePipe]
})
export class BreakEarlyComponent implements OnInit {

  areas:string[];
  envs:string[];
  dataSource:BreakEarlyArea[];
  site:string;

  subscription: Subscription;

  constructor(private route: ActivatedRoute,private router: Router,
    private beService: BreakEarlyService,
    private calendarService: CalendarService, 
    public dialog: MatDialog) { }

  ngOnInit(): void {
    let lines:string[] = this.route.snapshot.paramMap.get('lines').split('&'); 
    console.log("lines", lines);

    this.site = this.route.snapshot.paramMap.get('site')
    let myAreas:string[] = [];
    let myEnvs:string[] = [];

    // Extract Area and Env from each line
    lines.forEach(function(line) {
      let parts = line.split('-');
      
      myAreas.push(parts[0]);
      myEnvs.push(parts[1]);

    });

    this.envs = Array.from(new Set(myEnvs)); // Deduplicate envs
    this.areas = myAreas;
    this.getBreakEarlyList();
  }

  getBreakEarlyList() {
    if (this.subscription) this.subscription.unsubscribe();
    this.subscription = this.beService.getBreakearlyList(this.envs, this.areas).subscribe(
      (out) => {
        console.log("Data", out);
        this.dataSource = out['Body'];
      }
    ) 
  }

  startBreakEarly(Area:string, ShiftDate:Date, Shift:string) {
    const dialogRef = this.dialog.open(ReasonDialogComponent,{
      width:'250px',
      data: {reason: ""}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.calendarService.isLoading.next(true); // Set progress spinner
        this.beService.breakEarly(this.envs, Area, ShiftDate, Shift, result.reason).pipe(first()).subscribe(
          out => {
            console.debug("Started Break Early", out);
            this.getBreakEarlyList(); // Force immediate refresh since we know data just updated
            this.calendarService.isLoading.next(false); // Turn off progress spinner
          }
        );
      }
    });
  }

  onBack() {
    this.router.navigate(['/area', 'select', this.site, 'breakearly', 'ALL']);
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }  


}
